import { Pipe, PipeTransform } from '@angular/core';
import { LocationDto } from '../dto';

@Pipe({
    name: 'getGeoCoords'
})
export class GetGeoCoordsPipe implements PipeTransform {
    transform(location: LocationDto): { lon: number, lat: number } {
        let hqLocations = location;
        if (Array.isArray(location)) {
            hqLocations = location.find((location) => location.is_ushq === true);
        }
        return hqLocations?.geo_coords || { lon: 0, lat: 0 }
    }
}